import { render, staticRenderFns } from "./PickupPointModalWindow.vue?vue&type=template&id=50a00921&scoped=true&"
import script from "./PickupPointModalWindow.vue?vue&type=script&lang=js&"
export * from "./PickupPointModalWindow.vue?vue&type=script&lang=js&"
import style0 from "./PickupPointModalWindow.vue?vue&type=style&index=0&id=50a00921&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a00921",
  null
  
)

export default component.exports